import React from 'react';

import withReservation from '../utils/Reservation';

const propTypes = {};

const code = [
  'ArrowUp',
  'ArrowUp',
  'ArrowDown',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowLeft',
  'ArrowRight',
  'b',
  'a',
];
class ResetReservation extends React.Component {
  constructor(...args) {
    super(...args);

    document.addEventListener('keyup', this.handleKeyUp);
    this.lastIndex = -1;
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleKeyUp);
  }

  handleKeyUp = ({ key }) => {
    clearTimeout(this.timer);
    setTimeout(() => {
      this.lastIndex = -1;
    }, 5000);

    if (this.resetting) return;

    this.lastIndex++;
    const nextKey = code[this.lastIndex];

    if (nextKey !== key) {
      if (this.lastIndex > 1) console.log("You didn't say the magic word");
      this.lastIndex = -1;
      return;
    }
    console.log(key, this.lastIndex, code.length);
    if (this.lastIndex === code.length - 1) {
      this.resetReservation();
    }
  };

  resetReservation = async () => {
    const { cart } = this.props;
    this.resetting = true;
    console.log('resetting reservation...');
    await cart.testingResetReservation();
  };

  render() {
    return null;
  }
}

ResetReservation.propTypes = propTypes;

export default withReservation(ResetReservation);
